import { store } from "@/store/stores"
import userService from "./userService"
import trainingFeatureAccess from "./trainingFeatureAccess"
import customerHubPreferences from "./customerHubPreferences"

// Own Health reads/link references only. Never use this for Watch, administration,
// other members' data, or native exports. Both inputs are fresh session grants.
const ownHealthFeatureAccess = {
  isAllowed() { return trainingFeatureAccess.isAllowed() || customerHubPreferences.isEnabled() },
  capture() {
    if (!this.isAllowed()) return null
    try { return JSON.stringify([String(userService.getUserId() || ""), localStorage.getItem("token") || "", this.state.revision]) }
    catch (_) { return null }
  },
  isCurrent(grant) { return grant !== null && grant === this.capture() },
  subscribe(listener) {
    return store.watch(() => `${this.capture() || ""}|${this.state.ready}`, () => { Promise.resolve().then(listener).catch(() => {}) })
  },
  async reject(grant, error) {
    if (!this.isCurrent(grant) || ![401, 403].includes(error?.response?.status)) return false
    // An ownership/studio rejection need not mean the pilot right was removed.
    // Recheck both existing grant sources without granting Watch to a pilot.
    const checks = []
    if (trainingFeatureAccess.isAllowed()) checks.push(trainingFeatureAccess.reject(trainingFeatureAccess.capture(), error))
    if (customerHubPreferences.isAllowed()) checks.push(customerHubPreferences.refresh())
    await Promise.allSettled(checks)
    return true
  },
  state: {
    get ready() { return trainingFeatureAccess.state.ready && customerHubPreferences.state.ready },
    get userId() { return ownHealthFeatureAccess.isAllowed() ? String(userService.getUserId() || "") : "" },
    get revision() {
      return trainingFeatureAccess.isAllowed() ? `legacy:${trainingFeatureAccess.state.revision}`
        : customerHubPreferences.isEnabled() ? `customer:${customerHubPreferences.state.revision}` : "denied"
    },
  },
}

export default ownHealthFeatureAccess
